// extracted by mini-css-extract-plugin
module.exports = {"grid":"NftCard_grid__3E4DT","box":"NftCard_box__2-Q--","card":"NftCard_card__3MYqP","cardHeader":"NftCard_cardHeader__3x-ZW","cardBody":"NftCard_cardBody__301Mn"};